import { ModelConfigParams, genericApplicationChecklistMFG, genericApplicationChecklistQC } from "./model-config-params";

export const gynecology: ModelConfigParams = {
  bodyParts: [
    'endometrioma',
    'fibroid',
    'cystGynecology',
    'arteryWithUncertain',
    'veinWithUncertain',
    'uterus',
    'bladder',
    'ureter',
    'endometrium',
    'myometrium',
    'ovary',
    'fallopianTubes',
    'bowel',
    'colonMRI',
    'fluid',
    'unknown',
  ],
  tissueHotkeys: {
    tumour: 'q',
    fibroid: 'w',
    cystGynecology: 'e',
    uterus: 'r',
    endometrium: 't',
    ovary: 'y',
    bladder: 'u',
    ureter: 'i',
    colon: 'o',
    bowel: 'p',
    tethering: 'alt + q',
    artery: 'alt + w',
    arteryUncertain: 'alt + e',
    vein: 'alt + r',
    veinUncertain: 'alt + t',
    myometrium: 'alt + y',
    fallopianTubes: 'alt + u',
    fluid: 'alt + i',
    unknown: 'alt + o',
  },
  checklist: genericApplicationChecklistMFG,
  checklistQC: genericApplicationChecklistQC,
  defaultIntensityRange: [0, 2000],
}
